// import { ColumnDef } from "@tanstack/react-table"
import type { ColumnDef } from "@tanstack/react-table";
import type { Category } from "./data-table"
import { Button } from "../../components/button"
import { useNavigate } from "react-router-dom"

type ColumnOptions = {
  onEdit: (id: string) => void
  onDelete: (id: string) => void
}

export const categoryColumns = ({ onEdit, onDelete }: ColumnOptions): ColumnDef<Category>[] => [
  {
    accessorKey: "name",
    header: "Name",
    cell: ({ row }) => row.original.name,
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => (
      <span
        className={`px-2 py-1 text-xs rounded ${
          row.original.status === "Enabled" ? "bg-green-200" : "bg-red-200"
        }`}
      >
        {row.original.status}
      </span>
    ),
  },
  {
    id: "actions",
    header: "Edit",
    cell: ({ row }) => {
      const navigate = useNavigate()
      const category_id = row.original.category_id
      return (
        <div className="flex gap-2">
          <Button onClick={() => navigate(`/Category/edit/${category_id}`)}>Edit</Button>
          <Button variant="destructive" onClick={() => onDelete(category_id)}>
            Delete
          </Button>
        </div>
      )
    },
  },
]